
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface PointsDeduction {
  id: number;
  team: string;
  season: string;
  points: number;
  reason: string | null;
  created_at: string;
  created_by: string;
  league: string;
}

export const usePointsDeductions = (season?: string) => {
  return useQuery({
    queryKey: ['points-deductions', season],
    queryFn: async () => {
      let query = supabase
        .from('points_deductions')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (season) {
        query = query.eq('season', season);
      }

      const { data, error } = await query;
      
      if (error) throw error;
      return (data || []) as PointsDeduction[];
    },
    staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes
    gcTime: 30 * 60 * 1000 // Cache persists for 30 minutes
  });
};
